import React from 'react';
import { components } from 'react-select';

const LoadingMessage = (props) => <components.LoadingMessage {...props} />;

export default LoadingMessage;
